/**
 * @generated SignedSource<<be9f160222dab341d123273585a8b779>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TiktokGoStatus = "approved" | "pending" | "rejected";
export type ApplyTiktokGoCreatorMutationInput = {
  apply: boolean;
  clientMutationId?: string | null;
  tiktokGoUniqueId?: string | null;
};
export type SnsAssociationTiktokApplyTtgoMutation$variables = {
  input: ApplyTiktokGoCreatorMutationInput;
};
export type SnsAssociationTiktokApplyTtgoMutation$data = {
  readonly applyTiktokGoCreator: {
    readonly id?: string;
    readonly message?: string;
    readonly profile?: {
      readonly isTiktokGoCreator: boolean;
      readonly tiktokGoStatus: TiktokGoStatus;
      readonly tiktokGoUniqueId: string | null;
    };
  };
};
export type SnsAssociationTiktokApplyTtgoMutation = {
  response: SnsAssociationTiktokApplyTtgoMutation$data;
  variables: SnsAssociationTiktokApplyTtgoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTiktokGoCreator",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokGoStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokGoUniqueId",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UserError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SnsAssociationTiktokApplyTtgoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "applyTiktokGoCreator",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SnsAssociationTiktokApplyTtgoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "applyTiktokGoCreator",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56885b66632e0ab8161c46771fe55b03",
    "id": null,
    "metadata": {},
    "name": "SnsAssociationTiktokApplyTtgoMutation",
    "operationKind": "mutation",
    "text": "mutation SnsAssociationTiktokApplyTtgoMutation(\n  $input: ApplyTiktokGoCreatorMutationInput!\n) {\n  applyTiktokGoCreator(input: $input) {\n    __typename\n    ... on Influencer {\n      id\n      profile {\n        isTiktokGoCreator\n        tiktokGoStatus\n        tiktokGoUniqueId\n        id\n      }\n    }\n    ... on UserError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec70635ef57fcf90d35d18e05c10da89";

export default node;
